module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_5010.a76c6eb9.png";